import React, { ReactNode } from 'react'
import { ButtonBase, Typography } from '@mui/material'

export const DataTableExpandToggle = ({
    label,
    contentLabel,
    isExpanded,
    onClick,
}: {
    label: ReactNode
    contentLabel: string
    isExpanded: boolean
    onClick: () => void
}) => (
    <ButtonBase
        disableRipple
        onClick={onClick}
        aria-expanded={isExpanded}
        aria-label={`${isExpanded ? 'Hide' : 'Show'} ${contentLabel}`}
        sx={{
            borderRadius: '50%',
            color: 'figma.primary',
            height: 40,
            justifyContent: 'center',
            minWidth: 40,
            ml: -1,
            transition: 'background-color 0.2s ease',
            bgcolor: isExpanded ? 'figma.primary2' : 'transparent',
            '&:hover': {
                bgcolor: isExpanded ? 'figma.primary2' : 'figma.primary3',
            },
        }}
    >
        <Typography variant="16x400" color="inherit">
            {label}
        </Typography>
    </ButtonBase>
)

export default DataTableExpandToggle
